export default function JoinJourney() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-5 sm:px-8 sm:py-8">
      <div className="relative isolate overflow-hidden rounded-[24px] shadow-[0_10px_30px_rgba(114,9,183,0.15)] sm:rounded-[32px] min-h-[320px] sm:min-h-[360px] flex flex-col items-center justify-center text-center px-5 py-14 sm:px-14 sm:py-16">
        {/* Desktop Image */}
        <img
          src="/img/about-us/Join-the-Journey.svg"
          alt="Palm-lined road leading toward a sunset"
          className="hidden md:block absolute inset-0 -z-10 h-full w-full object-cover object-center"
        />
        {/* Mobile Image */}
        <img
          src="/img/about-us/Join-mobile-view.svg"
          alt="Palm-lined road leading toward a sunset"
          className="block md:hidden absolute inset-0 -z-10 h-full w-full object-cover"
        />

        <div className="mx-auto flex max-w-2xl flex-col items-center pb-20 sm:pb-24">
          <div>
            <h3 className="font-display text-[22px] font-bold text-white sm:text-4xl">
              Join the Journey
            </h3>
            <p className="mt-2 text-[12px] leading-relaxed text-gray-100 sm:mt-4 sm:text-[14px]">
              Whether you're planning your first solo adventure or you're an
              experienced traveler exploring your next destination,
              SoloConnect is here to help you discover the world together.
            </p>
          </div>

          <p className="font-display text-[14px] font-medium text-white sm:text-xl">
            Travel Better. Connect Smarter.
          </p>
        </div>
      </div>
    </section>
  );
}
